import loadable from '@loadable/component'

export const LinkboxCarousel = loadable(() => import('./LinkboxCarousel'))
export const LinkboxCarouselItem = loadable(
  () => import('./LinkboxCarouselItem'),
)
export const LinkboxCarouselItemOverlay = loadable(
  () => import('./LinkboxCarouselItemOverlay'),
)
